module.exports = __webpack_public_path__ + "static/media/full.5286ddad.jpg";